
export default [
  {
    url: "/dashboard",
    name: "Dashboard",
    slug: "dashboard",
    icon: "HomeIcon",
  },
  {
    url:'/usertypes',
    name:'User',
    slug:'usertypes',
    icon:'ColumnsIcon'
  },
  {
    url:'/roles/role-permission',
    name:'Role Permission',
    slug:'roles-permission',
    icon:'StarIcon'
  },
  // {
  //   url: "/accounts",
  //   name: "Accounts",
  //   slug: "book",
  //   icon: "BookIcon",
  // } ,{
  //   url: "/campaigns",
  //   name: "Campaigns",
  //   slug: "campaign",
  //   icon: "StarIcon"
  // },
  // {
  //   url: null,
  //   name: "User",
  //   icon: "UserIcon",
  //   i18n: "User",
  //   submenu: [
  //     {
  //       url: '/elomark-users',
  //       name: "ElomarkUser",
  //       slug: "elomark-users",
  //       i18n: "EyeIcon",
  //     },
  //     {
  //       url: '/client-users',
  //       name: "ClientUser",
  //       slug: "elomark-users",
  //       i18n: "EyeIcon",
  //     },
  //   ]
  // },
]
